enum ProductImageTypes {
  logo = 1,
  banner = 2,
}

export default ProductImageTypes;
